import IntegrationTable from '@/components/shared/IntegrationTable/IntegrationTable';
import Bot from '../icons/Bot';
import { integrationFieldPresets } from '@/components/shared/IntegrationTable/integrationFieldPresets';
import MundBotConversa from '../icons/MundBotConversa';

export default function BotConversa() {
  return (
    <IntegrationTable
      integrationKey='bot_conversa'
      title='BotConversa'
      main_icon={<MundBotConversa />}
      icon={<Bot />}
      fields={[
        integrationFieldPresets.postback_url,
        integrationFieldPresets.status,
      ]}
    />
  );
}
